import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_ERROR,
  AUTH_CHECK,
  AUTH_GET_PERMISSIONS,
} from "react-admin";

import decodeJwt from "jwt-decode";
import { emitLogout } from "./lib/authEvents";

const authUrl = "/auth";

let decToken = null;
let rawToken = null;

export const getDecodedToken = () => {
  if (decToken) {
    return decToken;
  }

  if (process.env.NODE_ENV === "development") {
    decToken = JSON.parse(localStorage.getItem("dtoken"));
    return decToken;
  }

  return null;
};

export const getToken = () => {
  if (rawToken) {
    return rawToken;
  }

  if (process.env.NODE_ENV === "development") {
    rawToken = localStorage.getItem("token");
    return rawToken;
  }

  return null;
};

export const validTokenExists = () => getDecodedToken() && decToken.id;

export const getStationId = () => {
  if (!validTokenExists()) {
    console.warn("Can't find token for stationid");
    return null;
  }

  return decToken.stationid;
};

const clearLogin = () => {
  decToken = null;
  rawToken = null;

  if (process.env.NODE_ENV === "development") {
    localStorage.setItem("token", null);
    localStorage.setItem("dtoken", null);
  }
};

const setLogin = token => {
  rawToken = token;
  decToken = decodeJwt(token);

  if (process.env.NODE_ENV === "development") {
    localStorage.setItem("token", token);
    localStorage.setItem("dtoken", JSON.stringify(decToken));
  }
};

export default (type, params) => {
  // called when the user attempts to log in
  if (type === AUTH_LOGIN) {
    const { username, password } = params;
    const request = new Request(authUrl, {
      method: "POST",
      body: JSON.stringify({ username, password }),
      headers: new Headers({ "Content-Type": "application/json" }),
    });
    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(({ token }) => {
        setLogin(token);
      });
  }
  // called when the user clicks on the logout button
  if (type === AUTH_LOGOUT) {
    clearLogin();
    emitLogout();
    return Promise.resolve();
  }
  // called when the API returns an error
  if (type === AUTH_ERROR) {
    const { status } = params;
    if (status === 401 || status === 403) {
      clearLogin();
      return Promise.reject();
    }
    return Promise.resolve();
  }
  // called when the user navigates to a new location
  if (type === AUTH_CHECK) {
    return validTokenExists();
  }
  // called when we need to check if the user can access a page
  if (type === AUTH_GET_PERMISSIONS) {
    const { role } = getDecodedToken();
    return role ? Promise.resolve(role) : Promise.reject();
  }
  return Promise.reject(new Error("Unknown method"));
};



// WEBPACK FOOTER //
// ./src/authProvider.js